import React from 'react';
import { useTranslation } from 'react-i18next';
import { HiddenProps } from './types';
import HiddenLayout from './HiddenLayout';
import Blocked from './Icons/Blocked';
import Button from '../../Button';

const ArtistBlockedOverlay: React.FC<HiddenProps> = ({
  deviation: { deviationId, author },
  deviation,
  unblockDeviant,
  ...props
}) => {
  const { t } = useTranslation();
  return (
    <HiddenLayout
      deviation={deviation}
      icon={<Blocked />}
      title={t('deviationview.blocked.artist')}
      text={t('deviationview.blocked.artist.text')}
      button={
        author && (
          <Button
            view="b14"
            height="medium"
            onClick={() => author && unblockDeviant(author.userId, deviationId)}
          >
            {t('deviationview.blocked.unblockDeviant')}
          </Button>
        )
      }
      {...props}
    />
  );
};
ArtistBlockedOverlay.displayName = 'ArtistBlockedOverlay';

export default ArtistBlockedOverlay;
